/**
 * Single source of truth for app version + build timestamp.
 *
 * Bump APP_VERSION + BUILD_DATE every time we ship a user-visible
 * change so the UI footer reflects what's actually running.
 *
 * Semver guidance:
 *  - MAJOR  (x.0.0): breaking UI/API change, big rewrites.
 *  - MINOR  (3.x.0): new feature (multi-coin, regime preview, etc).
 *  - PATCH  (3.0.x): bug fix, UX tweak, copy change, perf.
 *
 * If you ship multiple small fixes in one session, bundle them
 * under a single PATCH bump (e.g. v3.4.0 → v3.4.1 covers 6 fixes).
 *
 * CHANGELOG lives at /app/memory/PRD.md "Implemented (with dates)"
 * — keep that and the version here in sync.
 */

export const APP_VERSION = "3.8.33";

// Use YYYYMMDD.HHMM (UTC) so it's monotonic, sortable, and matches
// the user's existing footer format. Update on every ship.
export const BUILD_DATE = "20261007.1700";
